import React from 'react';

export const ButtonStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'none',
  border: 'none',
  borderRadius: '50%',
  outline: 'none',
  flexShrink: 0,
  transition: 'background-color 150ms ease',
  WebkitTapHighlightColor: 'transparent',
};

export const ButtonHoverStyle: React.CSSProperties = {
  backgroundColor: 'rgba(0,0,0,0.04)',
};

export const ButtonFocusStyle: React.CSSProperties = {
  boxShadow: '0 0 0 2px rgba(25,118,210,0.5)',
};

export const ButtonDisabledStyle: React.CSSProperties = {
  cursor: 'not-allowed',
  opacity: 0.5,
  pointerEvents: 'none',
};

export const ButtonEnabledStyle: React.CSSProperties = {
  cursor: 'pointer',
};

export const PaddingBySize: Record<
  'small' | 'medium' | 'large',
  React.CSSProperties
> = {
  small: { padding: '4px' },
  medium: { padding: '8px' },
  large: { padding: '12px' },
};
